module.exports = __webpack_public_path__ + "img/second-day-3.a10aa9ca.webp";